import clsx from "clsx";
import dndCss from "../styles/dnd.module.css";
import { observer } from "mobx-react-lite";
import React, { PropsWithChildren } from "react";
import { useDndStore } from "../store/dnd-store";

interface DashedOutlineWrapperProps extends PropsWithChildren {
	/** active border */
	active: boolean;
	/** show or hide outline */
	enabled: boolean;
}

/** Dashed outline wrapper - good for use with dnd drop zones */
export const DashedOutlineWrapper: React.FC<DashedOutlineWrapperProps> = observer(({
	active,
	children,
	enabled,
}) => {
	let top = 0;
	let bottom = 0;
	let height = 0;
	let width = 0;
	const { scrollPosition, scrollEl } = useDndStore();
	if (scrollEl) {
		const rect = scrollEl.getBoundingClientRect();
		const { scrollTop } = scrollEl;
		top = 0 + scrollTop;
		height = rect.height;
		bottom = 0 - scrollTop;
		width = rect.width;
	}
	return (
		<>
			{children}
			{enabled && (
				<div
					className={clsx(
						dndCss.dashedOutline,
						active && dndCss.dashedOutlineHorizontalActive,
						dndCss.dashedOutlineHorizontal,
					)}
					key={`csi-react-dnd-scroll-position-0-${scrollPosition}`}
					style={{ left: 0, height: 2, top, width }}
				/>
			)}
			{enabled && (
				<div
					className={clsx(
						dndCss.dashedOutline,
						active && dndCss.dashedOutlineVerticalActive,
						dndCss.dashedOutlineVertical,
						dndCss.dashedOutlineRight,
					)}
					key={`csi-react-dnd-scroll-position-1-${scrollPosition}`}
					style={{ right: 0, top, height, width: 2 }}
				/>
			)}
			{enabled && (
				<div
					className={clsx(
						dndCss.dashedOutline,
						active && dndCss.dashedOutlineHorizontalActive,
						dndCss.dashedOutlineHorizontal,
					)}
					key={`csi-react-dnd-scroll-position-2-${scrollPosition}`}
					style={{ bottom, left: 0, height: 2, width }}
				/>
			)}
			{enabled && (
				<div
					className={clsx(
						dndCss.dashedOutline,
						active && dndCss.dashedOutlineVerticalActive,
						dndCss.dashedOutlineVertical,
					)}
					key={`csi-react-dnd-scroll-position-3-${scrollPosition}`}
					style={{ left: 0, height, top, width: 2 }}
				/>
			)}
		</>
	);
});
